/* Rondea — collection : swap d'image au clic pastille + popover taille + ajout panier AJAX (drawer Dawn). */
(function () {
  'use strict';

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: cur }); }
    catch (e) { return (cents / 100).toFixed(2) + ' €'; }
  }
  function escapeHtml(s) {
    return (s || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- Swap pastille couleur ---------- */
  function handleSwatch(sw) {
    var card = sw.closest('[data-rcol-card]');
    if (!card) return;
    var img = card.querySelector('[data-card-img]');
    var url = sw.getAttribute('data-url');
    var newSrc = sw.getAttribute('data-img');
    var newSet = sw.getAttribute('data-srcset');

    if (img && img.tagName === 'IMG' && newSrc) {
      img.classList.add('is-swapping');
      var pre = new Image();
      pre.onload = function () { img.src = newSrc; if (newSet) img.srcset = newSet; img.classList.remove('is-swapping'); };
      pre.onerror = function () { img.classList.remove('is-swapping'); };
      pre.src = newSrc;
    }
    var hov = card.querySelector('[data-card-hover]');
    var newHov = sw.getAttribute('data-hover');
    if (hov && newHov) hov.src = newHov;
    if (url) card.querySelectorAll('[data-card-link]').forEach(function (a) { a.href = url; });

    var addBtn = card.querySelector('[data-add]');
    if (addBtn) {
      if (url) addBtn.setAttribute('data-url', url);
      var v = sw.getAttribute('data-variants');
      if (v) addBtn.setAttribute('data-variants', v);
    }
    card.querySelectorAll('[data-swatch]').forEach(function (s) { s.classList.remove('is-active'); s.removeAttribute('aria-current'); });
    sw.classList.add('is-active');
    sw.setAttribute('aria-current', 'true');
  }

  /* ---------- Popover taille ---------- */
  var lastFocus = null;

  function openPopover(addBtn) {
    var section = addBtn.closest('[data-rcol-section]');
    if (!section) return;
    var pop = section.querySelector('[data-pop]');
    var sizes = section.querySelector('[data-pop-sizes]');
    var title = section.querySelector('[data-pop-title]');
    if (!pop || !sizes) return;

    var variants = [];
    try { variants = JSON.parse(addBtn.getAttribute('data-variants') || '[]'); } catch (e) { variants = []; }
    var tname = addBtn.getAttribute('data-title') || '';
    if (title) title.textContent = tname ? tname : 'Choisir une taille';

    sizes.innerHTML = '';
    if (!variants.length) {
      var a = document.createElement('a');
      a.href = addBtn.getAttribute('data-url') || '#';
      a.className = 'rcol-size';
      a.textContent = 'Voir le produit';
      sizes.appendChild(a);
    } else {
      variants.forEach(function (v) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rcol-size';
        b.disabled = !v.available;
        b.setAttribute('data-variant-id', v.id);
        b.innerHTML = '<span class="rcol-size__name">' + escapeHtml(v.size) + '</span>' +
                      '<span class="rcol-size__price">' + money(v.price) + '</span>';
        if (v.available) b.addEventListener('click', function () { addToCart(v.id, b); });
        sizes.appendChild(b);
      });
    }

    lastFocus = addBtn;
    pop.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var first = sizes.querySelector('button:not(:disabled), a');
    if (first) first.focus();
  }

  function closePopover(section, keepFocus) {
    var pop = section.querySelector('[data-pop]');
    if (!pop || pop.hidden) return;
    pop.hidden = true;
    document.documentElement.style.overflow = '';
    if (!keepFocus && lastFocus) { lastFocus.focus(); }
    lastFocus = null;
  }

  /* ---------- Ajout panier (drawer/notification Dawn) ---------- */
  function addToCart(variantId, btn) {
    if (btn) btn.classList.add('is-busy');
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var sectionIds = (cart && cart.getSectionsToRender) ? cart.getSectionsToRender().map(function (s) { return s.id; }) : [];

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }], sections: sectionIds, sections_url: window.location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.status) { if (btn) btn.classList.remove('is-busy'); return; } // erreur (stock…)
        var section = btn && btn.closest('[data-rcol-section]');
        if (cart && typeof cart.renderContents === 'function') {
          if (section) closePopover(section, true);
          cart.renderContents(data); // ouvre le drawer/notification
        } else {
          document.location = root + 'cart';
          return;
        }
        if (btn) btn.classList.remove('is-busy');
      })
      .catch(function () { if (btn) btn.classList.remove('is-busy'); });
  }

  /* ---------- Délégation d'événements ---------- */
  document.addEventListener('click', function (e) {
    var sw = e.target.closest('[data-swatch]');
    if (sw) { handleSwatch(sw); return; }
    var add = e.target.closest('[data-add]');
    if (add) { openPopover(add); return; }
    var pop = e.target.closest('[data-pop]');
    if (e.target.closest('[data-pop-close]') || (pop && !e.target.closest('[data-pop-panel]'))) {
      var section = e.target.closest('[data-rcol-section]');
      if (section) closePopover(section);
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      document.querySelectorAll('[data-rcol-section]').forEach(function (s) { closePopover(s); });
    }
  });
})();
